import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';

export type DocumentListItemRemovedAction = {
	type: 'DOCUMENT_LIST_ITEM_REMOVED';
	payload: DocumentDetailPayload;
};

export default (payload: DocumentDetailPayload): DocumentListItemRemovedAction => ({
	type: 'DOCUMENT_LIST_ITEM_REMOVED',
	payload,
});
